// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2VHx5","imageUploader":"EGiftCard_imageUploader__20XtM"};